import InputFileUpload from "../components/InputFileUpload";
import {useContext, useEffect, useRef, useState} from "react";
import { Context } from "../index";
import { observer } from "mobx-react-lite";
import { upload, getStatus } from "../http/ruleApi";
import RuleChooser from "../components/rule/RuleChooser";
import Button from "@mui/material/Button";
import ContractChooser from "../components/contract/ContractChooser";
import { useNavigate } from "react-router-dom";
import {FILE_ROUTE, MAIN_ROUTE} from "../utils/constants";
import PeriodChooser from "../components/PeriodChooser";
import { jwtDecode } from "jwt-decode";
import Modal from "@mui/material/Modal";
import FileUploadProgress from "../components/FileUploadProgress/FileUploadProgress";
import Box from "@mui/material/Box";


const UploadForm = observer(() => {
  const navigate = useNavigate();
  const { user } = useContext(Context);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const [rule, setRule] = useState(null);
  // const [contract, setContract] = useState(null);
  const [period, setPeriod] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState([]);
  let loadingVar = false;

  const handleOpen = () => setLoading(true);
  const handleClose = () => setLoading(true);

  let timeOutFunc;

  const prevDataRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getStatus();

        if (response?.length) {
          // Глубокое сравнение данных
          const hasChanged = JSON.stringify(response) !== JSON.stringify(prevDataRef.current);

          if (hasChanged) {
            setProgress(response);
            prevDataRef.current = response;
          }
        }

        console.log(loading);
      } catch (error) {
        console.error('Ошибка:', error);
      }
    };

    const interval = setInterval(fetchData, 1000);
    fetchData();

    return () => clearInterval(interval);
  }, [loading]);

  const handleFileUpload = async () => {
    const token = localStorage.getItem("token");
    const { id } = jwtDecode(token);
    const p = period.year + "/" + period.quarter;
    setLoading(true);
    setError("");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", id);
    formData.append("rule", JSON.stringify(rule));
    // formData.append("contract", JSON.stringify(contract));
    formData.append("period", p);
    try {
      // updateStatus();
      const response = await upload(formData);
      console.log(response);
      setLoading(false);
      return navigate(FILE_ROUTE + "/" + response.data.fileId);
    } catch (error) {
      console.log(error.response.data.message);
      setError(error.response.data.message);
      setLoading(false);
    }
  };

  console.log(rule);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "2%",
        margin: "2%",
      }}
    >
      <div style={{ marginBottom: "2rem" }}>
        <RuleChooser rule={rule} setRule={setRule} />
      </div>
      {/*<div style={{ marginBottom: "2rem" }}>*/}
      {/*  <ContractChooser contract={contract} setContract={setContract} />*/}
      {/*</div>*/}

      <PeriodChooser
          setPeriod={setPeriod}
          period={period.year + "/" + period.quarter}
          type={'from'}
      />

      {error && <div style={{ color: "red" }}>{error}</div>}


      <Box
          width={'100%'}
          p={2}
          flexDirection="column"
          justifyContent={'flex-start'}
          alignItems={"center"}
          style={{
            textAlign: "center"
          }}
      >
        <InputFileUpload
            setFile={setFile}
            rule={rule?.rule?.state}
        />
      </Box>

      <Button
          style={{
            marginBottom: "2rem",
            marginTop: "2rem",
          }}
          onClick={handleFileUpload}
          disabled={!file || !rule || !period}
          variant="contained"
          color="secondary"

      >
        Отправить файл на сервер
      </Button>
      <Modal
          open={loading}
          onClose={handleClose}
      >
        <Box
            sx={{width: "100%", height: "100%"}}
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
        >
          {progress.map(item => <FileUploadProgress loaded={item.loaded} fileName={item.fileName} />)}
        </Box>
      </Modal>
    </div>
  );
});

export default UploadForm;
